import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

export const getCongresoSitioConfig = () => {
  return authClient().get(`${API}/congreso-edicion/sitio-config`);
};

export const putCongresoSitioConfig = (body) => {
  return authClient().put(`${API}/congreso-edicion/sitio-config`, body);
};

export const getCongresoEdiciones = () => {
  return authClient().get(`${API}/congreso-edicion?getDisabled=true`);
};

export const getCongresoEdicionById = (id) => {
  return authClient().get(`${API}/congreso-edicion/${id}`);
};

export const deleteCongresoEdicion = (id) => {
  return authClient().delete(`${API}/congreso-edicion/${id}`);
};

export const postCongresoEdicion = async (edicion, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "congresos");
    edicion.headerImage = response?.data?.fileURL;
  }
  return authClient().post(`${API}/congreso-edicion`, edicion);
};

export const updateCongresoEdicion = async (id, edicion, selectedImage) => {
  if (selectedImage) {
    const response = await uploadSingleFile(selectedImage, "congresos");
    edicion.headerImage = response?.data?.fileURL;
  }
  return authClient().put(`${API}/congreso-edicion/${id}`, edicion);
};

export const changeStatusCongresoEdicion = async (id, active) => {
  return authClient().put(`${API}/congreso-edicion/change-status/${id}`, {
    active,
  });
};

export const setDefaultCongresoEdicion = async (id) => {
  return authClient().put(`${API}/congreso-edicion/set-default/${id}`);
};

/** Abre la web de congresos mostrando la edición como publicada (token ~30 min). */
export const postCongresoPreviewToken = (edicionId) => {
  return authClient().post(`${API}/congreso-edicion/preview-token`, {
    edicionId,
  });
};

export const getCongresoDelegadosByEdicion = (edicionId) => {
  return authClient().get(
    `${API}/congreso-edicion/delegados/edicion/${edicionId}`
  );
};

export const lookupCongresoDelegadoEmail = (email) => {
  return authClient().get(
    `${API}/congreso-edicion/delegados/lookup?email=${encodeURIComponent(email)}`
  );
};

export const updateCongresoDelegadoAcl = (aclId, body) => {
  return authClient().put(`${API}/congreso-edicion/delegados/acl/${aclId}`, body);
};

export const upsertCongresoDelegado = (body) => {
  return authClient().post(`${API}/congreso-edicion/delegados`, body);
};

export const deleteCongresoDelegado = (aclId) => {
  return authClient().delete(`${API}/congreso-edicion/delegados/${aclId}`);
};

export const getCongresoInscripcionesByEdicion = (edicionId, q) => {
  const qs = q && String(q).trim() ? `?q=${encodeURIComponent(String(q).trim())}` : "";
  return authClient().get(`${API}/congreso-edicion/${edicionId}/inscripciones${qs}`);
};

export const getCongresoContactosByEdicion = (edicionId, q) => {
  const qs = q && String(q).trim() ? `?q=${encodeURIComponent(String(q).trim())}` : "";
  return authClient().get(`${API}/congreso-edicion/${edicionId}/contactos${qs}`);
};

export const getCongresoInscripcionById = (edicionId, inscripcionId) => {
  return authClient().get(
    `${API}/congreso-edicion/${edicionId}/inscripciones/${inscripcionId}`
  );
};

export const getCongresoTalleresInscripciones = (edicionId) => {
  return authClient().get(
    `${API}/congreso-edicion/${edicionId}/talleres-inscripciones`
  );
};

export const postCongresoTallerInscripcion = (edicionId, body) => {
  return authClient().post(
    `${API}/congreso-edicion/${edicionId}/talleres-inscripciones`,
    body
  );
};

export const deleteCongresoTallerInscripcion = (edicionId, inscripcionTallerId) => {
  return authClient().delete(
    `${API}/congreso-edicion/${edicionId}/talleres-inscripciones/${inscripcionTallerId}`
  );
};

export const deleteCongresoInscripcionesBulk = (edicionId, ids) => {
  return authClient().delete(`${API}/congreso-edicion/${edicionId}/inscripciones`, {
    data: { ids },
  });
};

export const deleteCongresoTalleresInscripcionesBulk = (edicionId, ids) => {
  return authClient().delete(
    `${API}/congreso-edicion/${edicionId}/talleres-inscripciones`,
    { data: { ids } }
  );
};
